import { getLineItem } from '../../logic/line-item';
import { WritableAutoConfiguratorState } from '../slice';
import { revalidateFieldValuePreservingParseErrors } from './apply-validation';

/**
 * Validates the quantity of every quantity break on a line item.
 *
 * Quantity ordering is otherwise only evaluated as a side effect of editing a
 * field, so state that arrives wholesale — loaded from the server, imported
 * from a spreadsheet, or copied from another line — would carry no errors at
 * all until something on the line happened to be edited. Call this whenever a
 * line's quantity breaks are populated in bulk.
 */
export function revalidateLineQuantities(
  state: WritableAutoConfiguratorState,
  lineItemUuid: string,
) {
  const lineItem = getLineItem(state, lineItemUuid);

  for (const quantityBreakUuid of lineItem.quantityBreakUuids) {
    revalidateQuantity(state, quantityBreakUuid);
  }
}

/**
 * Revalidates one quantity break's quantity, leaving quantities the user has
 * not reached yet alone.
 *
 * An empty quantity carrying no errors is work in progress, so validating it
 * would report "Required" against a field nobody has had the chance to fill in.
 * Matches how `updateValue` only revalidates dependent fields that hold a value
 * or already have errors.
 */
export function revalidateQuantity(
  state: WritableAutoConfiguratorState,
  quantityBreakUuid: string,
) {
  const quantity = state.quantityBreaks[quantityBreakUuid]?.quantity;

  if (!quantity) {
    return;
  }

  if (quantity.value === null && quantity.errors.length === 0) {
    return;
  }

  revalidateFieldValuePreservingParseErrors(
    state,
    { model: 'quantityBreak', key: 'quantity' },
    { model: 'quantityBreak', key: 'quantity', uuid: quantityBreakUuid },
  );
}
